import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, EyeOffOutline, EyeOutline, Flex, Text } from '@bonusly/design-system';
import { useUser } from '@bonusly/user-queries';
import { useCurrentUser } from '@bonusly/who-am-i';

import { useEvaluation } from './context';

export const VisibilityBadge: FC = () => {
	const { t } = useTranslation('feedback');
	const evaluation = useEvaluation();
	const user = useCurrentUser();
	const { data: receiver } = useUser(evaluation.receiverId);

	const isSharedWithManager = (): boolean => {
		return receiver?.managerId ? evaluation.sharedTo(receiver?.managerId) : false;
	};

	const text = () => {
		if (isSharedWithManager()) {
			return t('visibility.shared');
		} else {
			return t('visibility.private');
		}
	};

	const icon = () => {
		if (isSharedWithManager()) {
			return <EyeOutline size="xs" mr={1} />;
		} else {
			return <EyeOffOutline size="xs" mr={1} />;
		}
	};

	if (!evaluation.receiverIs(user.id) || evaluation.giverIs(user.manager_id)) {
		return (
			<Flex alignItems="center">
				<Box color="gray.700" fontSize="medium" px={1} py="2px">
					|
				</Box>
				{icon()}
				<Text size="sm" color="gray.700" display="inline">
					{text()}
				</Text>
			</Flex>
		);
	}

	return null;
};
